import EventEmitter from '../helpers/EventEmmiter';

require('./e3-tour-help.scss');

const template = require('./e3-tour-help.html');

class E3TourHelp extends EventEmitter {
    _wrapper = null;
    _container = null;
    _contentNode = null;
    _closeButton = null;
    _options = {
        editor: true
    };

    _cache = '';

    _handlers = {};

    constructor(wrapper, options = {}, translationService){
        super();

        this._wrapper = wrapper;
        this._translationService = translationService;
        this._src = 'https://www.eyespy360.com/#/body_e3viewer_help.html';

        this._prepareOptions(options);
        this._init();
    }

    _prepareOptions(options) {
        Object.keys(this._options).forEach((key) => {
            if (options.hasOwnProperty(key)) this._options[key] = options[key];
        });
    }

    _init() {
        let {editor} = this._options;
        let container = document.createElement('div');

        container.classList.add('e3-tour-help');
        this._wrapper.appendChild(container);

        let viewer = this._initViewer(container);

        this._closeButton = viewer.querySelector('.help-viewer__body .help-close');
        this._contentNode = viewer.querySelector('.help-viewer__body');
        this._container = container;

        this._bindEvents()
    }

    _initViewer(container) {
        let wrapper = document.createElement('div');
        let body = document.createElement('div');
        let close = document.createElement('div');
        let iconClose = document.createElement('button');
            iconClose.classList.add('help-close');
        close.appendChild(iconClose);

        wrapper.classList.add('help-viewer');
        body.classList.add('help-viewer__body');

        body.appendChild(close)
        wrapper.appendChild(body);
        container.appendChild(wrapper);

        return wrapper;
    }

    _bindEvents() {
        let close = this._closeButton;
        let closeHandler = this._options.editor ? this.cancel.bind(this) : this.hide.bind(this);

        this._handlers.close = {
            element: close,
            handler: closeHandler
        };

        close.addEventListener('click', closeHandler);
    }

    _unbindEvents() {
        Object.keys(this._handlers).forEach((key) => {
            let element = this._handlers[key].element;
            let handler = this._handlers[key].handler;

            element.removeEventListener('click', handler);

            delete this._handlers[key];
        });
    }

    _show() {
        this._container.classList.add('show');
    }

    _hide() {
        this._container.classList.remove('show');
    }

    _insertBody(body) {
        this._cache = body;
        this._contentNode.appendChild(body);
    }

    _updateCache() {
        this._cache = this._contentNode.innerHTML;
    }

    getContent() {
        return this._contentNode.innerHTML;
    }

    isDirty() {
        return this._contentNode.innerHTML !== this._cache
    }

    createIframe(){
        const iframe = document.createElement('iframe');
        iframe.src = this._src;

        return iframe;
    }

    appendIframe(){
        const iframe = this.createIframe();
              iframe.width = '100%';
              iframe.height = '100%';

        this.show(iframe);
    }

    show(body) {
        this._insertBody(body);
        this._show();

        if (this._editor) this._editor.focus();
    }

    hide() {
        this._hide();
        this._fireEvent('tour-help.cancel');
    }

    cancel() {
        let promise = Promise.resolve();

        promise
            .then(() => this.hide())
            .catch((e) => { 
                console.error(e);
                /* ... */ })
    }

    isShown() {
        return this._container.classList.contains('show');
    }

    destroy() {
        this._unbindEvents();

        this._wrapper.removeChild(this._container);
    }
}

export default E3TourHelp;
